import React from 'react';
import { FontIcon, CircularProgress } from 'material-ui';

const RightIcon = ({ subMenus, gettingData, isUpdated }) => {
  if (subMenus) {
    if (gettingData) return <CircularProgress size={15} style={{ float: 'right', top: '-16px' }} />;
    if (subMenus.length) return <FontIcon className="tc-icon-chevron-down" color="white" style={{ float: 'right', marginRight: '10px', top: '-2px' }}/>;
    return <span></span>;
  }
  return <span></span>;
};

export default RightIcon;



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/left-nav/right-icon.jsx